import { Form } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import api from 'services/api';

const Ownership = ({ state, onChange }) => {
  const { config } = state;
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [usersResponse, rolesResponse] = await Promise.all([api.get('/users'), api.get('/roles')]);

        setUsers(usersResponse.data?.users ?? []);
        setRoles(rolesResponse.data?.roles ?? rolesResponse.data ?? []);
      } catch (error) {
        console.error('Failed to fetch ownership data:', error);
        setUsers([]);
        setRoles([]);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="mb-4">
      <h5>Ownership</h5>

      <Form.Group className="mb-2" controlId="formOwnerUser">
        <Form.Label>Owner User</Form.Label>
        <Form.Select name="owner_user" value={config?.owner_user || ''} onChange={(e) => onChange(e, true)}>
          <option value="">Select a user</option>
          {(Array.isArray(users) ? users : []).map((user) => (
            <option key={user.user_id} value={user.user_id}>
              {user.username}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-2" controlId="formOwnerRole">
        <Form.Label>Owner Role</Form.Label>
        <Form.Select name="owner_role" value={config?.owner_role || ''} onChange={(e) => onChange(e, true)}>
          <option value="">Select a role</option>
          {(Array.isArray(roles) ? roles : []).map((role) => (
            <option key={role.role_id} value={role.role_id}>
              {role.name}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </div>
  );
};

export default Ownership;
